module.exports = __webpack_public_path__ + "img/why-icon-1.f6cbfd8c.svg";